import React from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  ticketHeader: {
    display: "flex",
    alignItems: "center",
    minHeight: 72,
    backgroundColor: theme.palette.type === "dark" ? "#162221" : "#ffffff",
    backgroundImage: theme.palette.type === "dark"
      ? "linear-gradient(90deg, rgba(20,184,166,0.08), transparent 60%)"
      : "linear-gradient(90deg, rgba(13,148,136,0.06), transparent 60%)",
    flex: "none",
    boxShadow: "none",
    borderBottom: `1px solid ${theme.palette.divider}`,
    // só o botão de voltar
    "& > .MuiButton-root:first-child": {
      minWidth: 40,
      borderRadius: 10,
      marginLeft: 8,
    },
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      padding: "4px 0",
    },
  },
}));

const TicketHeader = ({ loading, children }) => {
  const classes = useStyles();
  const history = useHistory();
  const handleBack = () => {
    history.push("/atendimentos");
  };

  return (
    <>
      {loading ? (
        <TicketHeaderSkeleton />
      ) : (
        <Card square className={classes.ticketHeader}>
          <Button color="primary" onClick={handleBack}>
            <ArrowBackIos />
          </Button>
          {children}
        </Card>
      )}
    </>
  );
};

export default TicketHeader;
